import React from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { TooltipIconButton } from '@paragon/client-tools';

import { createOrAddToBundleFromQuantitiesByAnalysisSetGuid } from '../../../../actions/bundleActions';
import { getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTabNotBundledByAnalysisSetGuid } from '../../../../selectors/getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTabNotBundledByAnalysisSetGuid';
import { useAppDispatch, useAppSelector } from '../../../hooks';

interface AddAnotherToThisBundleProps {
  readonly instanceGuid: string | undefined;
}

export function AddAnotherToThisBundle(props: AddAnotherToThisBundleProps) {
  const { instanceGuid } = props;
  const dispatch = useAppDispatch();
  const productionComponentInstances = useAppSelector((state) => state.productionComponentInstances);
  const productionComponentInstancesNotBundledByAnalysisSetGuid = useAppSelector(
    getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTabNotBundledByAnalysisSetGuid,
  );

  const analysisSetGuid =
    instanceGuid === undefined ? null : productionComponentInstances[instanceGuid].analysisSetGuid;
  const isAnotherAvailableToAdd =
    (!!analysisSetGuid && productionComponentInstancesNotBundledByAnalysisSetGuid[analysisSetGuid]?.length > 0) ??
    false;

  return (
    <TooltipIconButton
      title="Add another of these to the bundle"
      disabled={instanceGuid === null || !isAnotherAvailableToAdd}
      onClick={() =>
        analysisSetGuid &&
        instanceGuid &&
        void dispatch(
          createOrAddToBundleFromQuantitiesByAnalysisSetGuid(
            { [analysisSetGuid]: 1 },
            productionComponentInstances[instanceGuid].bundleGuid,
          ),
        )
      }
    >
      <AddCircleIcon />
    </TooltipIconButton>
  );
}
